
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/analytics-services",
      function () {
        return require("private-next-pages/services/analytics-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/analytics-services"])
      });
    }
  